import {
  CampaignConfigDto,
  DiscountDto,
  PopulatedCampaignUserDtoStatusEnum,
  PopulatedCampaignUserRefereeDto,
} from '@coretava/api/ecommerce-service';
import React from 'react';
import RefereeCongrats from './steps/congrats/RefereeCongrats';
import Invite from './steps/Invite';
import ReferrerCongrats from './steps/congrats/ReferrerCongrats';

type Props = {
  campaign: CampaignConfigDto,
  refereeCampaignUser?: PopulatedCampaignUserRefereeDto,
  discount?: DiscountDto,
  refereeDiscount?: DiscountDto,
  status: PopulatedCampaignUserDtoStatusEnum
}

const ReferralCampaign: React.FC<Props> = ({
  campaign, refereeCampaignUser, discount, refereeDiscount, status,
}) => React.useMemo(() => {
  if (refereeCampaignUser && refereeDiscount && !refereeCampaignUser.converted) {
    return <RefereeCongrats refereeCampaignUser={refereeCampaignUser} refereeDiscount={refereeDiscount} />;
  }
  if (status === PopulatedCampaignUserDtoStatusEnum.Pending) {
    return <Invite campaign={campaign} />;
  }
  if (status === PopulatedCampaignUserDtoStatusEnum.Valid && discount) {
    return <ReferrerCongrats campaign={campaign} discount={discount} />;
  }
  return undefined;
}, [campaign, status, refereeCampaignUser, discount, refereeDiscount]);

export default ReferralCampaign;
